/* global gt_ajax_object:readonly */

import { Api_Error } from '@app/utils/api-error'

/**
 * Shared REST client for Goehler Tool scripts.
 */
export class Goehler_Tool_REST_Client {

    /**
     * Führt einen GET-Request aus.
     *
     * @param route  REST-Route relativ zur WP-REST-Root.
     * @param params Query-Parameter.
     *
     * @throws {Api_Error}
     *
     * @returns Geparste Antwortdaten.
     */
    async get( route: string, params: Record<string, string | number> = {} ): Promise<unknown> {
        const query = new URLSearchParams(
            Object.entries( params ).map( ( [ key, value ] ) => [ key, String( value ) ] )
        )
        const endpoint = `${gt_ajax_object.root}${route}?${query}`

        return this.request_json(
            endpoint,
            {
                method: 'GET',
                headers: this.get_headers(),
                credentials: 'same-origin',
            },
            'rest_get'
        )
    }

    /**
     * Perform a REST POST request and return parsed JSON.
     *
     * @param {string} route REST route relative to WP REST root.
     * @param data
     * @returns {Promise<Object>}
     */
    async post( route: string, data = {} ): Promise<object> {
        return this.request_json(
            `${gt_ajax_object.root}${route}`,
            {
                method: 'POST',
                headers: this.get_headers(),
                credentials: 'same-origin',
                body: JSON.stringify( data ),
            },
            'rest_post'
        )
    }

	/**
	 * Perform a REST DELETE request and return parsed JSON.
	 *
	 * @param {string} route REST route relative to WP REST root.
	 * @param {Object} [params={}] Query parameters.
	 * @returns {Promise<Object>}
	 */
	async delete( route: string, params = {} ) {
		const query = new URLSearchParams( params )
		const endpoint = `${gt_ajax_object.root}${route}?${query}`

		return this.request_json(
			endpoint,
			{
				method: 'DELETE',
				headers: this.get_headers(),
                credentials: 'same-origin',
			},
			'rest_delete'
		)
	}

    async request_json( endpoint: string, options: object, debug_prefix: string ) {
        console.log( `[${debug_prefix} request]`, { endpoint: endpoint, options: options } )

        const response = await fetch( endpoint, options )
        console.log( `[${debug_prefix} raw response]`, response )

        const data = await response.json().catch( () => null )

        if ( ! response.ok ) {
            throw new Api_Error( data, response.status )
        }

        console.log( `[${debug_prefix} parsed data]`, data )
        return data
    }

    /**
     * Baut die Standard-Header für authentifizierte REST-Requests.
     */
    get_headers() {
        return {
            'Content-Type': 'application/json',
            'X-WP-Nonce': gt_ajax_object.rest_nonce,
        }
    }
}
